import "@babel/polyfill";
// import { window_size } from "./modules/theme";
// import { viewport_less_than_360 } from "./modules/viewport";
// import { humburger_menu } from "./modules/humburger-menu";
// import { scroll_hint } from "./modules/scrollhint";
import { smf_auto_zipaddr } from "./modules/smf";

smf_auto_zipaddr();

// window_size();
// viewport_less_than_360();
// humburger_menu();
// scroll_hint();
